import type { FC, PropsWithChildren } from "react";

export const AuthHeaderTitle: FC<PropsWithChildren> = props => {
	const {
		children
	} = props;

	return (
		<h1 className="type-display">
			{children}
		</h1>
	);
};
